import {
  FindingSeverity,
  FindingSeverityLabel,
  FindingState,
  FindingStateLabel,
  Source,
  SourceLabel,
} from "stores/FindingStore";

import { GenericObject } from "utility/misc";

// -----------------------------------------------------------------------------

export const SeverityAll = { title: "All", severity: undefined, all: true };

export const SeveritiesAll: SeverityEntry[] = [
  {
    title: FindingSeverityLabel[FindingSeverity.EarlyAccessInfo],
    severity: FindingSeverity.EarlyAccessInfo,
    all: false,
  },
  {
    title: FindingSeverityLabel[FindingSeverity.Info],
    severity: FindingSeverity.Info,
    all: false,
  },
  {
    title: FindingSeverityLabel[FindingSeverity.Low],
    severity: FindingSeverity.Low,
    all: false,
  },
  {
    title: FindingSeverityLabel[FindingSeverity.Medium],
    severity: FindingSeverity.Medium,
    all: false,
  },
  {
    title: FindingSeverityLabel[FindingSeverity.High],
    severity: FindingSeverity.High,
    all: false,
  },
  {
    title: FindingSeverityLabel[FindingSeverity.Critical],
    severity: FindingSeverity.Critical,
    all: false,
  },
];

export const Severities: SeverityEntry[] = [SeverityAll, ...SeveritiesAll];

export const SeveritiesDefaults: SeverityEntry[] = [SeverityAll];

export const SeveritiesByEnum: GenericObject = SeveritiesAll.reduce(
  (obj: GenericObject, entry: SeverityEntry) => {
    obj[entry.severity as FindingSeverity] = entry;

    //
    return obj;
  },
  {}
);

// -----------------------------------------------------------------------------

export const StateAll: StateEntry = {
  title: "All Open",
  state: undefined,
  all: true,
};

export const StatesAll: StateEntry[] = [
  {
    title: FindingStateLabel[FindingState.Acknowledged],
    state: FindingState.Acknowledged,
    all: false,
  },
  {
    title: FindingStateLabel[FindingState.New],
    state: FindingState.New,
    all: false,
  },
  {
    title: FindingStateLabel[FindingState.Notified],
    state: FindingState.Notified,
    all: false,
  },
  {
    title: FindingStateLabel[FindingState.Resolved],
    state: FindingState.Resolved,
    all: false,
  },
  {
    title: FindingStateLabel[FindingState.Suppressed],
    state: FindingState.Suppressed,
    all: false,
  },
  {
    title: FindingStateLabel[FindingState.Source_Disconnected],
    state: FindingState.Source_Disconnected,
    all: false,
  },
];

export const States: StateEntry[] = [StateAll, ...StatesAll];

export const StatesDefaults: StateEntry[] = [StateAll];

export const StatesByEnum: GenericObject = StatesAll.reduce(
  (obj: GenericObject, entry: StateEntry) => {
    obj[entry.state as FindingState] = entry;

    //
    return obj;
  },
  {}
);

// -----------------------------------------------------------------------------

export const SourceAll: SourceEntry = {
  title: "All",
  source: undefined,
  all: true,
};

export const SourcesAll: SourceEntry[] = [
  { title: SourceLabel[Source.AWSScan], source: Source.AWSScan, all: false },
  { title: SourceLabel[Source.GCPScan], source: Source.GCPScan, all: false },
  { title: SourceLabel[Source.Box], source: Source.Box, all: false },
  {
    title: SourceLabel[Source.GithubScan],
    source: Source.GithubScan,
    all: false,
  },
  // TODO: remove distinction between GoogleScan and GoogleEvent for filtering
  {
    title: SourceLabel[Source.GoogleScan],
    source: Source.GoogleScan,
    all: false,
  },
  {
    title: SourceLabel[Source.GoogleEvent],
    source: Source.GoogleEvent,
    all: false,
  },
  { title: SourceLabel[Source.Okta], source: Source.Okta, all: false },
  { title: SourceLabel[Source.M365], source: Source.M365, all: false },
  {
    title: SourceLabel[Source.AzureScan],
    source: Source.AzureScan,
    all: false,
  },
];

export const Sources: SourceEntry[] = [SourceAll, ...SourcesAll];

export const SourcesDefaults: SourceEntry[] = [SourceAll];

export const SourcesByEnum: GenericObject = SourcesAll.reduce(
  (obj: GenericObject, entry: SourceEntry) => {
    obj[entry.source as Source] = entry;

    //
    return obj;
  },
  {}
);

// -----------------------------------------------------------------------------

export type Entry = SeverityEntry | StateEntry | SourceEntry;

interface BaseEntry extends GenericObject {
  title: string;
  all: boolean;
}

export interface SeverityEntry extends BaseEntry {
  severity: FindingSeverity | undefined;
}

export interface StateEntry extends BaseEntry {
  state: FindingState | undefined;
}

export interface SourceEntry extends BaseEntry {
  source: Source | undefined;
}
